'use client';
import { createContext, useContext, useEffect, useState } from 'react';

import Personalize from '@contentstack/personalize-edge-sdk';

let sdkInstance = null;
export async function getPersonalizeInstance() {
  if (typeof window !== 'undefined' && !Personalize.getInitializationStatus()) {
    sdkInstance = await Personalize.init(
      process.env.NEXT_PUBLIC_CONTENTSTACK_PERSONALIZE_PROJECT_UID
    );
  }
  return sdkInstance;
}
const PersonalizeContext = createContext(null);
export function PersonalizeProvider({ children }) {
  const [sdk, setSdk] = useState(null);

  useEffect(() => {
    getPersonalizeInstance().then(setSdk).catch(console.error);
  }, []);
  return (
    <PersonalizeContext.Provider value={sdk}>
      {children}
    </PersonalizeContext.Provider>
  );
}
export function usePersonalize() {
  return useContext(PersonalizeContext);
}
